module.exports = __webpack_public_path__ + "img/member_rights_icon_431006.165202b4.png";